/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Errors_FailedInputs */

const he_auth_signup_errors_failed = /** @type {(inputs: Auth_Signup_Errors_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת החשבון נכשלה`)
};

const en_auth_signup_errors_failed = /** @type {(inputs: Auth_Signup_Errors_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create account`)
};

/**
* | output |
* | --- |
* | "Failed to create account" |
*
* @param {Auth_Signup_Errors_FailedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_errors_failed = /** @type {((inputs?: Auth_Signup_Errors_FailedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Errors_FailedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_errors_failed(inputs)
	return en_auth_signup_errors_failed(inputs)
});